<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('chargeTravailTech.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mgt-20px">
      <div class="column is-4 pdb-0">
        <div class="no-box-shadow-card card height-80 border-color-select">
          <div class="card-header height-80">
            <div class="imgFaceSansListe mgv-auto" v-if="!technicienSelect">
              <div class="imgFaceSansListe_logo">
              </div>
            </div>
            <img :src="technicienInformation.logo"
                 v-else-if="technicienInformation.logo && technicienSelect" alt=""
                 class="image is-32x32 mg-auto mgl-20px mgr-20px"/>
            <avatar :username="technicienInformation.nom" v-else :size="32"
                    class="mg-auto mgl-20px mgr-20px"/>
            <div class="mgv-auto pdr-20px
            is-size-6 has-text-weight-bold height-fit-content has-text-link">
              {{ technicienInformation.nom }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level columns mgt-20px">
      <div class="level-left column is-8">
        <div class="columns">
          <div class="column is-narrow pdr-0">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      :disabled="getAllOtsSelect.length === 0"
                      @click="checkPermissions(constantes.ORDRE_TRAVAIL.maj)
                      ? updateAffectationVisualisation() : showPopUp()"
                      :class="{ 'button-access-no-permission'
                      : !checkPermissions(constantes.ORDRE_TRAVAIL.maj)
                      || getAllOtsSelect.length === 0}">
                {{ $t('chargeTravailTech.actions.affecter')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="level-right column is-4 columns">
        <div class="column is-narrow">
          <button class="button" @click="updateRessourceVisualisation">
            {{ $t('chargeTravailTech.ressources', {
            nbRessources: ressources.length })}}
          </button>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="typeOt" slot-scope="props" >
        {{ getLibelleTypeIntervention(props.row.typeOtId )}}
      </div>
      <div slot="etat" slot-scope="props" >
        {{ getLibelleEtat(props.row.etat )}}
      </div>
      <div slot="dateSouhaitee" slot-scope="props" >
        {{ props.row.dateSouhaitee | formatDate }}
      </div>
      <div slot="datePlanification" slot-scope="props" >
        {{ props.row.datePlanification | formatDate }}
      </div>
      <div slot="dateRealisation" slot-scope="props" >
        {{ props.row.dateRealisation | formatDate }}
      </div>
      <div slot="technicien" slot-scope="props">
        {{ props.row.fournisseur ? props.row.fournisseur.nomCommercial : null }}
      </div>
      <div slot="montantHt" slot-scope="props" class="has-text-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="patrimoine" slot-scope="props"
           v-if="props.row.otPatrimoine">
        {{ props.row.otPatrimoine.adresse | adresse }}
      </div>
    </v-server-table>
    <div class="ressourceLayout" v-if="ressourceVisualisation">
      <ressource-charge-travail
        ref="ressourceChargeTravail"
        :nb-ot-sans-technicien="nbOtSansTechnicien"
        :technicienSelect="technicienSelect"
        :ressources="ressources"
        :critere-recherche="critereRecherche"
        @updateDates="updateDates"
        @recherche="recherche()"
        @updateTechnicienSelect="updateTechnicienSelect"
        @close="ressourceVisualisation = false">
      </ressource-charge-travail>
    </div>
    <div class="affectationLayout" v-if="affectationVisualisation">
      <affectation-charge-travail @close="updateRessourceVisualisation"
                                  @openAffectationPopUp="openAffectationPopUp"
                                  :nb-ot-sans-technicien="nbOtSansTechnicien"
                                  :ressources="ressources">
      </affectation-charge-travail>
    </div>
    <b-modal v-model="popUpAffecter"
             has-modal-card
             class="modal">
      <pop-up-affecter-technicien
        @affectation="affecterFromPopUpGestion"
        @close="popUpAffecter = false;"
        :info-base-for-affectation="technicienDateListeForAffectation">
      </pop-up-affecter-technicien>
    </b-modal>
    <b-modal v-model="popUpAffecterToDate" has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="$t('chargeTravailTech.popUpAffecter.messHeader')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @no="popUpAffecterToDate = false;"
                         @yes="affecter">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpDesaffecter" has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="$t('chargeTravailTech.popUpDesaffectation.messHeader')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @no="popUpDesaffecter = false;"
                         @yes="desaffecter">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import breadcrumb from '@/components/general/breadcrumb';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatIsoDate';
import TableItemsInView from '@/components/general/TableItemsInView';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  LIST_ETAT_OT_TECH,
  ETAT_EN_ATTENTE,
  ETAT_EN_COURS,
  ETAT_PLANIFIE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { getAll, affecterTechnicienOt } from '@/api/logistique/ordreTravailTech';
import formatageRessourceListe
  from '@/services/logistique/chargeTravail/technique/formatageResssourceListe';
import getLogo from '@/services/general/getLogo';
import ressourceChargeTravail
  from '@/components/logistique/chargeTravail/tech/ressource/ressourceChargeTravail';
import Avatar from 'vue-avatar';
import affectationChargeTravail
  from '@/components/logistique/chargeTravail/tech/affectation/affectationChargeTravail';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSuccess from '@/services/general/messageSucces';
import PopUpAffecterTechnicien
  from '@/components/logistique/chargeTravail/tech/affectation/p_affecterTechnicien';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_CHARGE_TRAVAIL_TECH } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const OT = createNamespacedHelpers('ordreTravailTech');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      constantes: {
        ORDRE_TRAVAIL,
      },
      ressourceVisualisation: true,
      affectationVisualisation: false,
      popUpAffecter: false,
      popUpDesaffecter: false,
      popUpAffecterToDate: false,
      otAAffecterIds: [],
      technicienSelect: null,
      nbOtSansTechnicien: 0,
      technicienInformation: {
        logo: null,
        nom: this.$i18n.t('chargeTravailTech.ressourceAndAffectationInfo.otNonAffecte'),
      },
      ressources: [],
      technicienDateListeForAffectation: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_CHARGE_TRAVAIL_TECH,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  components: {
    breadcrumb,
    TableItemsInView,
    ressourceChargeTravail,
    Avatar,
    affectationChargeTravail,
    PopUpPrevention,
    PopUpAffecterTechnicien,
    parametrageTable,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...OT.mapGetters({
      ots: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRechercheChargeTravail',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('chargeTravailTech.breadcrumb.liste'), route: '', isActive: true },
      ];
      return output;
    },
    columns() {
      return ['selected', 'code', 'typeOt', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'technicien', 'montantHt', 'patrimoine'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('chargeTravailTech.tabs.code'),
          etat: this.$t('chargeTravailTech.tabs.etat'),
          typeOt: this.$t('chargeTravailTech.tabs.type'),
          dateSouhaitee: this.$t('chargeTravailTech.tabs.dateSouhaite'),
          datePlanification: this.$t('chargeTravailTech.tabs.datePlanification'),
          dateRealisation: this.$t('chargeTravailTech.tabs.dateRealisation'),
          technicien: this.$t('chargeTravailTech.tabs.technicien'),
          montantHt: this.$t('chargeTravailTech.tabs.montantHt'),
          patrimoine: this.$t('chargeTravailTech.tabs.patrimoine'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.sansDatePremierAffichage) {
            data.query.datesPremierAffichage.dateDebut = null;
            data.query.datesPremierAffichage.dateFin = null;
            delete data.query.sansTiers;
          }
          if (!data.query.sansDatePremierAffichage && data.query.datesPremierAffichage) {
            data.query.datesPremierAffichage.dateDebut = formatDate(
              data.query.datesPremierAffichage.dateDebut,
            );
            data.query.datesPremierAffichage.dateFin = formatDate(
              data.query.datesPremierAffichage.dateFin,
            );
          }
          if (this.technicienSelect) {
            data.query.sansTiers = false;
            data.query.tiersId = [this.technicienSelect];
          } else {
            data.query.sansTiers = true;
            data.query.tiersId = [];
          }
          data.query.otEtat = [ETAT_EN_ATTENTE, ETAT_EN_COURS, ETAT_PLANIFIE];
          delete data.query.tiers;
          if (!data.query.agencesId || data.query.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadOrdreTravail(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.ots,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['code', 'etat', 'dateSouhaitee', 'datePlanification', 'dateRealisation', 'montantHt'],
      };
    },
    getAllOtsSelect() {
      return this.ots
        .filter((ot) => { return ot.selected; })
        .map(ot => ot.id);
    },
    allOTSelected() {
      return this.getAllOtsSelect.length === this.ots.length && this.ots.length > 0;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...OT.mapActions({
      loadOrdreTravail: 'loadOrdreTravail',
    }),
    openAffectationPopUp(infoTechnicienSelect) {
      if (infoTechnicienSelect.technicienId !== 'otNonAffecte') {
        this.technicienDateListeForAffectation = cloneDeep(infoTechnicienSelect);
        if (infoTechnicienSelect.technicienId === 'addTechnicien') {
          this.technicienDateListeForAffectation.technicienId = null;
        }
        if (infoTechnicienSelect.date) this.popUpAffecterToDate = true;
        else this.popUpAffecter = true;
      } else {
        this.technicienDateListeForAffectation = null;
        this.popUpDesaffecter = true;
      }
    },
    updateRessourceVisualisation() {
      this.affectationVisualisation = false;
      this.ressourceVisualisation = true;
    },
    updateAffectationVisualisation() {
      this.affectationVisualisation = true;
      this.ressourceVisualisation = false;
    },
    affecterFromPopUpGestion(info) {
      this.technicienDateListeForAffectation = cloneDeep(info);
      this.affecter();
    },
    async affecter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          otIds: this.getAllOtsSelect,
          tiersId: this.technicienDateListeForAffectation.technicienId,
          datePlanification: formatDate(this.technicienDateListeForAffectation.date),
          updateDatePlanification: true,
        };
        await affecterTechnicienOt(data);
        messageSuccess(this.$i18n.t('chargeTravailTech.popUpAffecter.messages.success.affecter'));
        this.reloadInfo();
        this.popUpAffecterToDate = false;
        this.popUpAffecter = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async desaffecter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          otIds: this.getAllOtsSelect,
          tiersId: null,
          updateDatePlanification: false,
        };
        await affecterTechnicienOt(data);
        messageSuccess(this.$i18n.t('chargeTravailTech.popUpAffecter.messages.success.desaffecter'));
        this.reloadInfo();
        this.popUpDesaffecter = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async getRessources() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          query: {
            societeId: this.societeActiveId,
            agencesId: this.agencesSelectionnees.map(agence => agence.agenceId),
            datesPremierAffichage: {
              dateDebut: formatDate(this.critereRecherche.datesPremierAffichage.dateDebut),
              dateFin: formatDate(this.critereRecherche.datesPremierAffichage.dateFin),
            },
            otEtat: [ETAT_EN_ATTENTE, ETAT_EN_COURS, ETAT_PLANIFIE],
          },
          limit: NO_PAGINATION,
        };
        const ots = (await getAll(data)).data.result.items;
        this.ressources = formatageRessourceListe(ots);
        this.nbOtSansTechnicien = ots.filter((ot) => {
          return ot.fournisseurId === null;
        }).length;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    updateDates(dateDebut, dateFin) {
      this.critereRecherche.datesPremierAffichage.dateDebut = moment(dateDebut);
      this.critereRecherche.datesPremierAffichage.dateFin = moment(dateFin);
      this.recherche();
      this.getRessources();
    },
    async updateTechnicienSelect(technicienId) {
      if (this.technicienSelect === technicienId) return;
      this.technicienSelect = technicienId;
      if (!technicienId) {
        this.technicienInformation = {
          logo: null,
          nom: this.$i18n.t('chargeTravailTech.ressourceAndAffectationInfo.otNonAffecte'),
        };
        this.critereRecherche.tiersId = [];
        this.critereRecherche.sansTiers = true;
      } else {
        const ressource = this.ressources.find((r) => { return r.technicienId === technicienId; });
        this.technicienInformation = {
          logo: await getLogo(technicienId),
          nom: ressource.technicien,
        };
      }
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    reloadInfo() {
      this.updateRessourceVisualisation();
      this.critereRecherche.sansDatePremierAffichage = false;
      this.getRessources();
      this.updateTechnicienSelect(null);
      this.recherche();
    },
    reloadPage() {
      this.critereRecherche.datesPremierAffichage.dateDebut = moment();
      this.critereRecherche.datesPremierAffichage.dateFin = moment().add(1, 'month');
      this.$refs.ressourceChargeTravail.changementDateFromParent();
      this.reloadInfo();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    getLibelleTypeIntervention(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async created() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (!this.critereRecherche.datesPremierAffichage
        || !this.critereRecherche.datesPremierAffichage.dateDebut
        || !this.critereRecherche.datesPremierAffichage.dateFin) {
        this.critereRecherche.datesPremierAffichage.dateDebut = moment();
        this.critereRecherche.datesPremierAffichage.dateFin = moment().add(1, 'month');
      }
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.reloadPage, this.goFirstPage);
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageLogistique.chargeTravail.listeTech'));
      await this.getRessources();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
